import { Dna } from "react-loader-spinner";
import i18n from "../../../language/i18n";
import { Icon } from "../../../library";
import { singleProfileItemStyles } from "./SingleProfileItemStyles";

type ProfileAccent = "teal" | "coral" | "purple";

interface SingleProfileItemProps {
  userProfile: any;
  selectedProfileId?: any;
  type?: string;
  accent?: ProfileAccent;
  onClick: () => void;
}

const MASCOT = "/mascots/mascot.webp";

const SingleProfileItem = (props: SingleProfileItemProps) => {
  const { userProfile, selectedProfileId, type, accent = "teal", onClick } =
    props;

  const isLearner = userProfile.role === "LEARNER";
  const isDeleted = !!userProfile.deleted;
  const isLoading = selectedProfileId === userProfile.id;

  const institutionName =
    userProfile?.branchDTO?.gradeDTO?.seasonDTO?.institutionDTO?.name;
  const orgText = isLearner ? institutionName || type : type;

  const chipText = isLearner
    ? [userProfile?.branchDTO?.gradeDTO?.name, userProfile?.branchDTO?.name]
        .filter(Boolean)
        .join(" · ")
    : userProfile.coterieType
    ? i18n.t(userProfile.coterieType)
    : "";

  return (
    <button
      type="button"
      className={`qdc-card qdc-card--${accent} ${
        isDeleted ? "qdc-deleted" : ""
      }`}
      onClick={() => {
        if (isDeleted) {
          return;
        }
        onClick();
      }}
    >
      <style>{singleProfileItemStyles}</style>
      <span className="qdc-sheen" aria-hidden="true"></span>
      <span className={`qdc-ring qdc-ring--${accent}`}>
        <img className="qdc-avatar" src={MASCOT} alt="" />
      </span>
      <span className={`qdc-name ${isDeleted ? "qdc-deleted-text" : ""}`}>
        {userProfile.name}
      </span>
      {orgText ? <span className="qdc-org">{orgText}</span> : null}
      {chipText ? (
        <span className={`qdc-chip qdc-chip--${accent}`}>{chipText}</span>
      ) : null}
      {isLoading ? (
        <span className="qdc-loader">
          <Dna
            visible={true}
            height="36"
            width="36"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </span>
      ) : (
        <span className="qdc-go">
          {i18n.t("enter")}
          <Icon name="arrow-right" size={14} />
        </span>
      )}
    </button>
  );
};

export default SingleProfileItem;
